import { type Component } from 'solid-js';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'white' | 'primary' | 'secondary';
  text?: string;
  fullscreen?: boolean;
}

const LoadingSpinner: Component<LoadingSpinnerProps> = (props) => {
  const size = () => props.size || 'md';
  const color = () => props.color || 'white';
  const text = () => props.text || 'Loading...';
  const fullscreen = () => props.fullscreen || false;

  const spinnerSizeClass = () => {
    switch (size()) {
      case 'sm': return 'w-4 h-4';
      case 'lg': return 'w-8 h-8';
      default: return 'w-6 h-6';
    }
  };

  const spinnerColorClass = () => {
    switch (color()) {
      case 'primary': return 'border-primary border-t-transparent';
      case 'secondary': return 'border-secondary border-t-transparent';
      default: return 'border-white border-t-transparent';
    }
  };

  const textColorClass = () => {
    switch (color()) {
      case 'primary': return 'text-primary';
      case 'secondary': return 'text-secondary';
      default: return 'text-white';
    }
  };

  return (
    <div
      class={`flex flex-col items-center justify-center gap-3 ${
        fullscreen() ? 'fixed inset-0 bg-gradient-primary z-50' : ''
      }`}
    >
      <div
        class={`${spinnerSizeClass()} ${spinnerColorClass()} border-2 rounded-full animate-spin`}
        style={{
          'border-color': color() === 'white' ? 'rgba(255,255,255,0.3)' : undefined,
          'border-top-color': color() === 'white' ? 'white' : undefined,
          animation: 'spin 1s linear infinite'
        }}
      />
      {text() && (
        <span class={`text-sm font-medium ${textColorClass()}`}>
          {text()}
        </span>
      )}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .animate-spin {
          animation: spin 1s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;